import { CssBaseline, ThemeProvider } from '@mui/material'
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { useDateFnsLocale } from '@/hooks/useDateFnsLocale.ts'
import { type AuthState } from '@/contexts'
import type { CompanyState } from '@/contexts/CompaniesContext'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { themeOptions } from '../themes/Theme.ts'
import { NotFoundComponent } from './-components/ErrorPages/NotFound.tsx'
import { SnackbarProvider } from 'notistack'
import { SnackbarNotification } from '@/components/FeedbackMessage/SnackbarNotification.tsx'

interface MyRouterContext {
  auth: AuthState
  company?: CompanyState
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: Root,
  notFoundComponent: NotFoundComponent,
  head: () => ({
    meta: [{ title: 'Flexis' }]
  })
})

function Root() {
  const dateFnsLocale = useDateFnsLocale()

  return (
    <ThemeProvider theme={themeOptions}>
      <SnackbarProvider
        maxSnack={15}
        Components={{
          default: SnackbarNotification,
          success: SnackbarNotification,
          info: SnackbarNotification,
          error: SnackbarNotification,
          warning: SnackbarNotification
        }}
      >
        <CssBaseline enableColorScheme />
        <HeadContent />
        <LocalizationProvider adapterLocale={dateFnsLocale} dateAdapter={AdapterDateFns}>
          <Outlet />
        </LocalizationProvider>
        <TanStackRouterDevtools />
      </SnackbarProvider>
    </ThemeProvider>
  )
}
